import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { auth, firestore } from "../../firebase";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import {
  IconButton,
  Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    margin: 10,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 9,
    marginTop: 9,
  },
  root1: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
}));

export default function Employee(props) {
  const classes = useStyles();
  const history = useHistory();
  const { managerId } = useParams();
  const [items, setItems] = useState([]);

  const [date, setDate] = useState('');
  var d = new Date();
  d.setMonth(d.getMonth() - 3);

  useEffect(() => {
    firestore.collection('ManagerTransactions').where('managerId', '==', managerId).where('timestamp', '>=', d).orderBy('timestamp','desc').limit(20).get().then(querySnapshot => {
      const listItems = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setItems(listItems);
    });

  }, [managerId]);

  items.sort(function(a,b){
    return new Date(b.transactionDate) - new Date(a.transactionDate);
  });

  return (
    <>
      <div className={classes.root1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper>
              <Box display="flex" flexGrow={1}>
                <IconButton onClick={() => { history.goBack()}} edge="end" color="inherit" aria-label="back">
                  <ArrowBackIosIcon />
                </IconButton>
                <Box flexGrow={1}>
                </Box>
                <Box flexGrow={1}>
                  <Typography className={classes.paper} variant="h6" component="h4">
                  Transactions
                  </Typography>
                </Box>
                <Box flexGrow={1}>
                </Box>
                <IconButton edge="start" color="inherit" aria-label="back">
                  <ArrowBackIosIcon htmlColor="white" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <TextField
          id="filled-number"
          label="Search Using Date"
          type="text"
          onInput={(e) => {
           setDate(e.target.value);
          }}
          placeholder="Sun Oct 03 2021"
          variant="outlined"
          fullWidth
          margin="normal"
          value={date}
        />
      <div>
        {items.filter(x => {
          if (date !== '') {
            return x.transactionDate.includes(date);
          }
          return true;
        }).map((item) => (
          <React.Fragment >
            <Card className={classes.root}>
              <CardContent>
                <Typography className={classes.pos}>
                  Created By: <u>{item.transactionDoneBy}</u>
                </Typography>
                <Typography className={classes.pos} >
                  Created Date: {item.transactionDate.replace('GMT+0530 (India Standard Time)','')}
                </Typography>
                <Typography className={classes.pos}>
                  Previous Points: {item.previousPoints} 
                </Typography>
                <Typography  className={classes.pos}>
                  Points Added: {item.pointsAdded} 
                </Typography>
                <Typography variant="h5" className={classes.pos}>
                  Balance: {item.balance}
                </Typography>
              </CardContent>
            </Card>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}

